import React, { useState, useEffect } from 'react'
import useRefresh from './useRefresh'

function useGetTime() {
  const { slowRefresh } = useRefresh()
  const [Time, setTime] = useState('day')

  useEffect(() => {
    function TimeCheck() {
      const myDate = new Date()
      const hrs = myDate.getHours()

      if (hrs < 7 || hrs >= 19) {
        setTime('night')
      } else {
        setTime('day')
      }
    }
    TimeCheck()
  }, [slowRefresh])

  return Time
}

export default useGetTime
